import { useContext } from "react";
import { AuthContext } from "./AuthenticationContext";
export { AuthContext, AuthContextProvider } from "./AuthenticationContext";

export { useWooUser } from "./WooUserContext";

export const useAuth = () => {
  return useContext(AuthContext);
};
